
import MessageSearch from "../../../assets/duotone/MessageSearch.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MessageSearchIcon({ className, dataTestid = "MessageSearchIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MessageSearch data-testid={dataTestid} className={classes} {...rest} />
  );
}
